import { Button, Tooltip, ButtonProps, TooltipProps } from '@panwds/react-ui'
import type { VFC } from 'react'

const TooltipButton: VFC<{
  children?: any,
  label: string,
  disabled?: boolean,
  buttonProps?: Omit<ButtonProps, 'disabled'>
  tooltipProps?: Omit<TooltipProps, 'label' | 'children'>
}> = ({ children, label, disabled = false, buttonProps = {}, tooltipProps = {} }) => {
  return (
    <Tooltip label={label} {...tooltipProps}>
      <div className='tw-p-0.5'>
        <Button
          disabled={disabled}
          {...buttonProps}
        >
          {children}
        </Button>
      </div>
    </Tooltip>
  )
}

export default TooltipButton
